import React from "react";
import { useLocation, useParams } from "react-router-dom";

import { useGameParamsContext } from "supercell-frontend-base/src/stores/gameParams";
import { useScrollEffect } from "supercell-frontend-base/src/utils/on-scroll-effect";
import { ClashOfClansGameParams } from "../../validation/game-params";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";

import { getProps } from "./get-props";

import { ArticleView } from "./view";

type Params = { id: string; variant?: string; slug?: string };

export const dim = (scrollTop: number) => {
    const heroElement: HTMLElement | null = document.querySelector(".hero");
    if (!heroElement) return;

    const scrolled = scrollTop / (heroElement?.clientHeight ?? 1);
    heroElement.style.opacity = `${1 - scrolled}`;
};

export const ArticleController = () => {
    const { pathname: pagePath } = useLocation();
    const { gameParams } = useGameParamsContext<ClashOfClansGameParams>();
    const { id, variant, slug } = useParams<Params>();
    const { trackPageView } = useSnowplowContext();

    const isolated =
        (variant && variant.toLowerCase() === "isolated") ||
        (slug && slug.toLowerCase() === "isolated");

    useScrollEffect(dim);

    const track = (article) => {
        trackPageView(article?.title ?? "", pagePath);
    };

    const props = {
        getProps: getProps(id, isolated, gameParams),
        id,
        track,
    };

    return <ArticleView {...props} />;
};
